import React from 'react';

const buttonStyle = {
    width: 'auto',
    height: 'auto',
    backgroundColor: 'transparent',
    color: 'white',
    border: '1px solid white',
    borderRadius: '10px',
    marginLeft: '10px',
    marginRight: '10px',
    fontSize: '1em',
    padding: '5px 10px 5px 10px',
};

function YesNoButtons({ yesDispatch, noDispatch }) {
    // TODO: 50vh feels like a hack
    return (
        <div style={{ color: 'white', }}>
            <button style={buttonStyle} type="button" onClick={yesDispatch}>
                Yes
            </button>
            <button style={buttonStyle} type="button" onClick={noDispatch}>
                No
            </button>
        </div>
    );
}

export default YesNoButtons;
